import React from "react"
import {
  Main,
  Wrapper,
  RateBox,
  TextBox,
  GoldenButton,
  TabletButtonBox,
  StarsBox,
  HalfStar,
  Star,
} from "./style"
import { GoldButton } from "../../SearchComponent/style"
import { useStaticQuery, graphql } from "gatsby"

const GoogleSection = ({
  see_opinions,
  rating_quantity,
  rating_description,
  rating_name,
}) => {
  const query = useStaticQuery(graphql`
    query GoogleQuery(
      $places: GoogleReviewsPlacesFilterInput = { status: {} }
    ) {
      googleReviews(places: $places) {
        id
        places {
          result {
            rating
            user_ratings_total
          }
        }
      }
    }
  `)

  const sentence = (sentence, number) => {
    if (sentence) {
      const words = sentence.split(" ")
      const lastWord = words[words.length - 1]
      words.pop()
      words.push(number)
      words.push(lastWord)
      const fullSentence = words.join(" ")

      return fullSentence
    }
  }

  return (
    <>
      <Main>
        <Wrapper>
          <TextBox>
            <h4>{rating_name}</h4>
            <p>{rating_description}</p>
          </TextBox>

          <RateBox>
            <StarsBox>
              {[...Array(5)].map((star, i) => {
                const rating = query.googleReviews.places.result.rating
                const ratingValue = i + 1
                if (
                  rating - ratingValue >= -0.71 &&
                  rating - ratingValue <= -0.21
                ) {
                  return (
                    <HalfStar
                      version="1.1"
                      id="Warstwa_1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      key={i}
                    >
                      <g id="XMLID_41_">
                        <path
                          id="XMLID_42_"
                          d="M45.9,5.2L34.1,29.1c-0.7,1.3-1.9,2.3-3.4,2.5L4.4,35.4c-3.7,0.5-5.2,5.1-2.5,7.8l19.1,18.6
		c1.1,1,1.6,2.6,1.3,4L17.7,92c-0.6,3.7,3.3,6.6,6.6,4.8l23.6-12.4c0.7-0.3,1.4-0.5,2.1-0.5V2.7C48.4,2.7,46.8,3.5,45.9,5.2z"
                        />
                      </g>
                    </HalfStar>
                  )
                } else {
                  return (
                    <Star
                      version="1.1"
                      id="Warstwa_1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      ratingValue={ratingValue}
                      rating={rating}
                      key={i}
                    >
                      <path
                        id="XMLID_422_"
                        d="M54.1,5.2l11.8,23.9c0.7,1.3,1.9,2.3,3.4,2.5l26.3,3.8c3.7,0.5,5.2,5.1,2.5,7.8L79.1,61.7
          c-1.1,1-1.6,2.6-1.3,4L82.3,92c0.6,3.7-3.3,6.6-6.6,4.8L52.1,84.4c-1.3-0.7-2.9-0.7-4.2,0L24.3,96.8c-3.3,1.8-7.2-1.1-6.6-4.8
          l4.5-26.2c0.3-1.5-0.2-3-1.3-4L1.8,43.2c-2.7-2.6-1.2-7.2,2.5-7.8l26.3-3.8c1.5-0.2,2.8-1.1,3.4-2.5L45.9,5.2
          C47.6,1.8,52.4,1.8,54.1,5.2z"
                      />
                    </Star>
                  )
                }
              })}

              <span>
                <p> {query.googleReviews.places.result.rating}</p>
                <p>/5</p>
              </span>
            </StarsBox>

            <p>
              {sentence(
                rating_quantity,
                query.googleReviews.places.result.user_ratings_total
              )}
            </p>
          </RateBox>

          <a
            href="https://www.google.com/maps/place//data=!4m2!3m1!1s0x4716477208cab961:0xa37d1dc8ab2b52d5?source=g.page.m.ad._"
            target="_blank"
          >
            <GoldenButton>{see_opinions}</GoldenButton>
          </a>
        </Wrapper>
      </Main>

      <TabletButtonBox>
        <div>
          <a
            href="https://www.google.com/maps/place//data=!4m2!3m1!1s0x4716477208cab961:0xa37d1dc8ab2b52d5?source=g.page.m.ad._"
            target="_blank"
          >
            <GoldButton>{see_opinions}</GoldButton>
          </a>
        </div>
      </TabletButtonBox>
    </>
  )
}

export default GoogleSection
